import { diaryActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [diaryActions.loadSuccess]: (state, action) => {
        return action.payload.entities.mcDiaryItems;
    },
    [diaryActions.resolveSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [diaryActions.markReadSuccess]: (state, action) => {
        state[action.payload].isRead = true;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        result = action.payload.mcDiaryItems.entities.mcDiaryItems ? action.payload.mcDiaryItems.entities.mcDiaryItems : {};
        return result;
    },


})


